import { render } from "./checkboxVee4.vue?vue&type=template&id=51e63348"
import script from "./checkboxVee4.vue?vue&type=script&lang=js"
export * from "./checkboxVee4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__